import type { ProcessedFileState } from '@atlaskit/media-client';

export interface ArtifactFormat {
	readonly type: string;
	readonly name: string;
}

export class ArtifactFormat {
	static fromProcessedFileState(
		processedFileState: ProcessedFileState,
	): ArtifactFormat | undefined {
		return (
			ArtifactFormat.fromMimeType(processedFileState.mimeType) ||
			ArtifactFormat.fromMediaType(processedFileState.mediaType)
		);
	}

	static fromMimeType(mimeType?: string): ArtifactFormat | undefined {
		const byMimeType: any = {
			'image/gif': {
				type: 'image/gif',
				name: 'original',
			},
		};

		if (mimeType) {
			return byMimeType[mimeType];
		}

		return undefined;
	}

	static fromMediaType(mediaType?: string): ArtifactFormat | undefined {
		const byMediaType: any = {
			doc: {
				type: 'application/pdf',
				name: 'document.pdf',
			},
			image: {
				type: 'image/jpeg',
				name: 'image.jpg',
			},
			audio: {
				type: 'audio/mpeg',
				name: 'audio.mp3',
			},
			video: {
				type: 'video/mp4',
				name: 'video_640.mp4',
			},
			archive: {
				type: 'not/supported',
				name: 'original',
			},
			model: {
				type: 'application/x-sea',
				name: 'model.sea',
			},
			unknown: {
				type: 'not/supported',
				name: 'original',
			},
		};

		if (mediaType) {
			return byMediaType[mediaType];
		}

		return undefined;
	}
}
